import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDot = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("circle", {
		cx: 9,
		cy: 9,
		r: 2,
		fill: "#D9DEEB"
	})
});
const ForwardRef = forwardRef(SvgDot);
export default ForwardRef;
